if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', class extends HTMLElement {
    connectedCallback() {
      this.scrollContainer = this.querySelector('[data-carousel-scroll]');
      if (!this.scrollContainer) return;

      this._handlePrev = this._handlePrev.bind(this);
      this._handleNext = this._handleNext.bind(this);
      this._handleScroll = this._updateArrows.bind(this);
      this._handleResize = this._updateArrows.bind(this);

      var prevBtn = this.querySelector('[data-carousel-prev]');
      var nextBtn = this.querySelector('[data-carousel-next]');
      if (prevBtn) prevBtn.addEventListener('click', this._handlePrev);
      if (nextBtn) nextBtn.addEventListener('click', this._handleNext);
      this._prevBtn = prevBtn;
      this._nextBtn = nextBtn;

      this.scrollContainer.addEventListener('scroll', this._handleScroll);
      window.addEventListener('resize', this._handleResize);
      this._updateArrows();
    }

    disconnectedCallback() {
      if (this._prevBtn) this._prevBtn.removeEventListener('click', this._handlePrev);
      if (this._nextBtn) this._nextBtn.removeEventListener('click', this._handleNext);
      if (this.scrollContainer) this.scrollContainer.removeEventListener('scroll', this._handleScroll);
      window.removeEventListener('resize', this._handleResize);
    }

    _handlePrev() {
      var width = this.scrollContainer.getBoundingClientRect().width;
      this.scrollContainer.scrollBy({ left: -Math.round(width * 0.7), behavior: 'smooth' });
    }

    _handleNext() {
      var width = this.scrollContainer.getBoundingClientRect().width;
      this.scrollContainer.scrollBy({ left: Math.round(width * 0.7), behavior: 'smooth' });
    }

    _updateArrows() {
      var sc = this.scrollContainer;
      var canScroll = sc.scrollWidth > sc.getBoundingClientRect().width;
      var atStart = sc.scrollLeft <= 0;
      var atEnd = sc.scrollLeft + sc.getBoundingClientRect().width >= sc.scrollWidth - 1;

      if (this._prevBtn) {
        this._prevBtn.disabled = !canScroll || atStart;
        this._prevBtn.classList.toggle('opacity-30', !canScroll || atStart);
        this._prevBtn.classList.toggle('cursor-not-allowed', !canScroll || atStart);
      }
      if (this._nextBtn) {
        this._nextBtn.disabled = !canScroll || atEnd;
        this._nextBtn.classList.toggle('opacity-30', !canScroll || atEnd);
        this._nextBtn.classList.toggle('cursor-not-allowed', !canScroll || atEnd);
      }
    }
  });
}
